import React, { useEffect, useRef } from 'react';
import { loadScript } from '~/utils';
import { EXTERNAL_URL } from '~/constants';

const WECHAT_LOGIN_HREF_CSS = '.impowerBox .status.status_browser { display: none; }';

// 微信登录（扫描二维码）
const WeChatLogin: React.FunctionComponent = () => {
    const thisRef = useRef<any>({
        weChatLogin: null
    });

    useEffect(() => {
        loadScript(EXTERNAL_URL.WECHAT_LOGIN_SCRIPT, () => {
            if (typeof window.WxLogin === 'function') {
                thisRef.current.weChatLogin = new window.WxLogin({
                    id: 'wechat-code',
                    ...window.jdy_wechat_open_config,
                    href: `data:text/css;base64,${window.btoa(WECHAT_LOGIN_HREF_CSS)}`
                });
            }
        });
    }, []);

    return (
        <div className="fx-wechat-login">
            <div id="wechat-code" />
        </div>
    );
};

export default WeChatLogin;
